var map = {
	"./BAT.png": 545,
	"./COMP.png": 253,
	"./DAI.png": 546,
	"./ETH.png": 547,
	"./UNI.png": 548,
	"./USDC.png": 549,
	"./USDT.png": 550,
	"./WBTC legacy.png": 551,
	"./WBTC.png": 552,
	"./ZRX.png": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544;